import TailwindModal from './TailwindModal';

export default TailwindModal;

